function ResponseStatusMapper(responseStatus: string) {
  const approvedStatuses = [
    'TransactionApproved',
    'TransactionPartiallyApproved',
    'TransactionRefunded',
    'TransactionPartiallyRefunded',
    'TransactionUpdated',
    'SavedPaymentMethodCreated',
    'SavedPaymentMethodUpdated',
    'SavedPaymentMethodDeleted',
    'PayorDeleted'
  ];

  const validationErrorStatuses = [
    'TransactionValidationError',
    'SavedPaymentValidationError',
    'SavedPaymentMethodCreateFailed',
    'SavedPaymentMethodUpdateFailed'
  ];

  const declinedStatuses = ['TransactionDeclined'];

  if (approvedStatuses.includes(responseStatus)) {
    return 'A';
  } else if (validationErrorStatuses.includes(responseStatus)) {
    return 'B';
  } else if (declinedStatuses.includes(responseStatus)) {
    return 'C';
  } else {
    return responseStatus;
  }
}

export default ResponseStatusMapper;
